// extracted by mini-css-extract-plugin
module.exports = {"container":"OfferGroup_container__rz0A_","offersContainer":"OfferGroup_offersContainer__1SrWr"};